"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.92,21.46H3.08a.51.51,0,0,1-.58-.58V3a.51.51,0,0,1,.58-.58H20.92A.51.51,0,0,1,21.5,3V20.88A.51.51,0,0,1,20.92,21.46Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.57,12l4.89-4.89a1.11,1.11,0,0,0-1.57-1.57L12,10.38,7.11,5.49A1.11,1.11,0,1,0,5.53,7.07L10.43,12,5.53,16.85a1.11,1.11,0,1,0,1.57,1.57L12,13.53l4.89,4.89a1.11,1.11,0,0,0,1.57-1.57Z",
    style: {
      fill: '#ffffff'
    }
  }));
};

exports["default"] = _default;